export const NOT_AUTHORIZED = 401;
export const FORBIDDEN = 403;
export const NOT_FOUND = 404;
export const CONFLICT = 409;
export const BAD_REQUEST = 400;
export const TOO_MANY_REQUESTS = 429;
export const PRECONDITION_FAILED = 412;
export const SERVICE_UNAVAILABLE = 503;
